var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlatform({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.994,
    height: 14.76,
    viewBox: "0 0 17.994 14.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "coin (1)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16402",
    d: "M2.3 51.221a13.56 13.56 0 0 0 3.744.718 6.853 6.853 0 0 1 8.262-3.5c-.211-.546-.8-1.172-2.2-1.687A14.651 14.651 0 0 0 7.2 46a14.7 14.7 0 0 0-4.9.753c-1.9.7-2.3 1.6-2.3 2.234s.4 1.534 2.3 2.234z",
    fill: "currentColor",
    transform: "translate(0 -46)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16403",
    d: "M2.3 196.406a12.888 12.888 0 0 0 3.17.672 6.864 6.864 0 0 1 .168-3.32 14.29 14.29 0 0 1-3.7-.755A6.133 6.133 0 0 1 0 191.92v2.252c0 .628.4 1.534 2.3 2.234z",
    transform: "translate(0 -186.792)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16404",
    d: "M5.779 318.769A14.407 14.407 0 0 1 1.936 318 6.132 6.132 0 0 1 0 316.92v2.252c0 .633.4 1.534 2.3 2.234a14.7 14.7 0 0 0 4.9.753c.432 0 .858-.015 1.274-.044a6.888 6.888 0 0 1-2.7-3.347z",
    transform: "translate(0 -307.399)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16405",
    d: "M187.8 136a5.8 5.8 0 1 0 5.8 5.8 5.8 5.8 0 0 0-5.8-5.8z",
    transform: "translate(-175.604 -132.837)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatform);
export default __webpack_public_path__ + "static/media/platform.e16919989780f7f1887cd9ac913d68f3.svg";
export { ForwardRef as ReactComponent };